"use strict";
/*
* Created on 28.11.2018
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowActionContext_1 = require("../model/WindowActionContext");

var WindowActionContextConverter_1 = require("./WindowActionContextConverter");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ForecastSimulationUpdateDTOConverter_1 = require("../../forecast-simulation/conversions/ForecastSimulationUpdateDTOConverter");
/**
 * @author MSu
 */


var WindowActionContextConverterImpl =
/*#__PURE__*/
function (_WindowActionContextC) {
  _inherits(WindowActionContextConverterImpl, _WindowActionContextC);

  function WindowActionContextConverterImpl(simulationDTOConverter) {
    var _this;

    _classCallCheck(this, WindowActionContextConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowActionContextConverterImpl).call(this));
    _this.simulationDTOConverter = simulationDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowActionContextConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowActionContext_1.WindowActionContext(WindowActionContext_1.WindowActionContext.schema.windowId.valueOfField(source), WindowActionContext_1.WindowActionContext.schema.actionType.valueOfField(source), WindowActionContext_1.WindowActionContext.schema.sessionId.valueOfField(source), WindowActionContext_1.WindowActionContext.schema.simActions.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        windowId: source.windowId,
        actionType: source.actionType,
        sessionId: source.sessionId,
        simActions: conversions.asObjectArray(source, 'simActions', function (simAction) {
          return _this2.simulationDTOConverter.toDocument(simAction, conversions);
        })
      };
    }
  }]);

  return WindowActionContextConverterImpl;
}(WindowActionContextConverter_1.WindowActionContextConverter);

WindowActionContextConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ForecastSimulationUpdateDTOConverter_1.ForecastSimulationUpdateDTOConverter])], WindowActionContextConverterImpl);
exports.WindowActionContextConverterImpl = WindowActionContextConverterImpl;